import {LeftArrow, OrderBookTooltipBody, OrderTooltip, RightArrow, TooltipArrow} from "../../styles/OrderBookStyles";
import {CFlexBetween, DText, FlexBetween} from "../../styles/CommonStyles";
import Text from "../../utils/Text";
import {formatNumber} from "../../utils/common";
import {useMainContext} from "../../contexts/main";
import {forwardRef, useRef} from "react";
import {TABLET_SIZE} from "../../constants/common";


const OrderBookTooltip = forwardRef((props, ref) => {

    const tooltipRef = useRef()
    const { market } = useMainContext()
    const {
        activeIndex,
        details
    } = props

    if (activeIndex === -1) return <></>

    const top = ref.current[activeIndex]?.offsetTop
    const isRight = ref.current[activeIndex]?.getBoundingClientRect()?.left < 300

    return (
        <OrderBookTooltipBody
            ref={tooltipRef}
            isRight={isRight}
            top={top}
        >
            <TooltipArrow>
                {
                    isRight ?
                        <LeftArrow size={18} />
                        :
                        <RightArrow size={18} />
                }
            </TooltipArrow>
            <OrderTooltip>
                <CFlexBetween>
                    <FlexBetween>
                        <DText><Text tid="avg-price" /></DText>
                        <DText>{formatNumber(details.avg, { type: market?.pair })}</DText>
                    </FlexBetween>
                    <FlexBetween>
                        <DText><Text tid="sum" /> {market.coin?.toUpperCase}</DText>
                        <DText>{formatNumber(details.sum)}</DText>
                    </FlexBetween>
                    <FlexBetween>
                        <DText><Text tid="total" /></DText>
                        <DText>{formatNumber(details.total, { type: market?.pair })}</DText>
                    </FlexBetween>
                </CFlexBetween>
            </OrderTooltip>
        </OrderBookTooltipBody>
    )
})

export default OrderBookTooltip
